// アプリ ⇄ MCP ブリッジ (ローカル WebSocket) のメッセージ。純ロジック (Node テスト可能)。
//
// タブ → ブリッジ: hello (コマンド一覧), result, event
// ブリッジ → タブ: call

export interface CommandInfo {
  id: string
  description: string
  params: unknown
  needsDocument: boolean
  readOnly: boolean
}

export type TabMessage =
  | { type: 'hello'; app: string; version: string; commands: CommandInfo[] }
  | { type: 'result'; id: number; result?: unknown; error?: { code: string; message: string } }
  | { type: 'event'; name: 'changed' | 'document-opened' | 'document-closed'; data?: unknown }

export type BridgeMessage = { type: 'call'; id: number; command: string; params?: unknown } | { type: 'ping' }

export interface CommandRunner {
  run(command: string, params: unknown): Promise<unknown>
}

/** ブリッジからのメッセージを処理して返信を作る (副作用は runner 経由だけ) */
export async function handleBridgeMessage(msg: unknown, runner: CommandRunner): Promise<TabMessage | null> {
  if (!msg || typeof msg !== 'object') return null
  const m = msg as BridgeMessage
  if (m.type === 'ping') return null
  if (m.type === 'call') {
    if (typeof m.id !== 'number' || typeof m.command !== 'string') return null
    try {
      const result = await runner.run(m.command, m.params ?? {})
      return { type: 'result', id: m.id, result: result === undefined ? null : result }
    } catch (e) {
      const code = (e as { code?: string }).code ?? 'failed'
      return { type: 'result', id: m.id, error: { code, message: e instanceof Error ? e.message : String(e) } }
    }
  }
  return null
}

export const DEFAULT_BRIDGE_PORT = 8765
